import { NgModule } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';
import { SimpleIconsMusescoreComponent } from './simple-icons-musescore.component';
 @NgModule({
    imports:      [ BrowserModule ],
    providers:    [],
    declarations: [ SimpleIconsMusescoreComponent ],
    exports:      [ SimpleIconsMusescoreComponent ],
    bootstrap:    []
})
export class SimpleIconsMusescoreModule {}
